import { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./PDFViewer.scss";
import Loader from "../loader-spinner/Loader";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

export default function PDFViewer({ pdfURL, onLoadSuccess: externalOnLoadSuccess }) {
  const [numPages, setNumPages] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setIsLoaded(true);
    if (externalOnLoadSuccess) {
      externalOnLoadSuccess({ numPages });
    }
  };

  useEffect(() => {
    if (pdfURL) {
      setIsLoaded(false);
      const loadPdf = async () => {
        const loadingTask = pdfjs.getDocument(pdfURL);
        await loadingTask.promise;
        setIsLoaded(true);
        if (externalOnLoadSuccess) {
          externalOnLoadSuccess();
        }
      };
      loadPdf();
    }
  }, [pdfURL, externalOnLoadSuccess]);

  return (
    <div className="pdf-viewer-container">
      {!isLoaded && <Loader isVisible={true} />}
      {pdfURL ? (
        <Document file={pdfURL} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (el, index) => (
            <div className="page-wrapper">
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={Math.min(windowWidth * 0.9, 900)}
                className="shadow-lg mb-4"
              />
            </div>
          ))}
        </Document>
      ) : (
        isLoaded && <p className="error">No PDFs available</p>
      )}
    </div>
  );
}
